/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * @export
 */
export const ProductHistoryDTOUpdateReasonEnum = {
    Source: 'SOURCE',
    Shipping: 'SHIPPING',
    Competitor: 'COMPETITOR',
    Own: 'OWN'
};
/**
 * Check if a given object implements the ProductHistoryDTO interface.
 */
export function instanceOfProductHistoryDTO(value) {
    return true;
}
export function ProductHistoryDTOFromJSON(json) {
    return ProductHistoryDTOFromJSONTyped(json, false);
}
export function ProductHistoryDTOFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'] == null ? undefined : json['id'],
        'inventoryId': json['inventoryId'] == null ? undefined : json['inventoryId'],
        'asin': json['asin'] == null ? undefined : json['asin'],
        'targetMarket': json['targetMarket'] == null ? undefined : json['targetMarket'],
        'quantity': json['quantity'] == null ? undefined : json['quantity'],
        'purchasePriceUsd': json['purchasePriceUsd'] == null ? undefined : json['purchasePriceUsd'],
        'availability': json['availability'] == null ? undefined : json['availability'],
        'shippingPriceUsd': json['shippingPriceUsd'] == null ? undefined : json['shippingPriceUsd'],
        'minSellingPrice': json['minSellingPrice'] == null ? undefined : json['minSellingPrice'],
        'minSellingPriceUsd': json['minSellingPriceUsd'] == null ? undefined : json['minSellingPriceUsd'],
        'sellingPrice': json['sellingPrice'] == null ? undefined : json['sellingPrice'],
        'sellingPriceUsd': json['sellingPriceUsd'] == null ? undefined : json['sellingPriceUsd'],
        'updateReason': json['updateReason'] == null ? undefined : json['updateReason'],
        'createdDate': json['createdDate'] == null ? undefined : (new Date(json['createdDate'])),
    };
}
export function ProductHistoryDTOToJSON(json) {
    return ProductHistoryDTOToJSONTyped(json, false);
}
export function ProductHistoryDTOToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'inventoryId': value['inventoryId'],
        'asin': value['asin'],
        'targetMarket': value['targetMarket'],
        'quantity': value['quantity'],
        'purchasePriceUsd': value['purchasePriceUsd'],
        'availability': value['availability'],
        'shippingPriceUsd': value['shippingPriceUsd'],
        'minSellingPrice': value['minSellingPrice'],
        'minSellingPriceUsd': value['minSellingPriceUsd'],
        'sellingPrice': value['sellingPrice'],
        'sellingPriceUsd': value['sellingPriceUsd'],
        'updateReason': value['updateReason'],
        'createdDate': value['createdDate'] == null ? undefined : ((value['createdDate']).toISOString()),
    };
}
